// Import the app shell — other views are lazy-loaded on navigation
import './components/app/cairn-app.js'
import { logger } from './utils/logger.js'

const log = logger.create('app')

// Import global styles
import './styles/app.css'

// Import MapLibre GL CSS for offline use
import 'maplibre-gl/dist/maplibre-gl.css'

// Import Material Symbols fonts for offline use
import '@material-symbols/font-400/outlined.css'

// Initialize the app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  void (async () => {
    // Initialize Capacitor if available
    if (typeof window !== 'undefined' && 'Capacitor' in window) {
      const { Capacitor } = await import('@capacitor/core')
      log.info('Capacitor platform:', Capacitor.getPlatform())

      // Platform-specific initialization
      if (Capacitor.isNativePlatform()) {
        const { StatusBar } = await import('@capacitor/status-bar')
        const { SplashScreen } = await import('@capacitor/splash-screen')

        // Configure status bar for dark theme (outdoor use)
        const { Style } = await import('@capacitor/status-bar')
        await StatusBar.setStyle({ style: Style.Dark }).catch(e => log.warn(e))

        // Hide splash screen after initialization
        await SplashScreen.hide().catch(e => log.warn(e))
      }
    }

    // Hide initial loading screen
    const loadingElement = document.getElementById('initial-loading')
    if (loadingElement) {
      loadingElement.style.display = 'none'
    }

    log.info('Cairn app initialized')
  })()
})

// Handle app state changes for performance
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    // App became visible - refresh data if needed
    log.debug('App became visible')
  } else {
    // App hidden - pause non-critical operations
    log.debug('App hidden')
  }
})
